import { render, staticRenderFns } from "./ChatMessage.vue?vue&type=template&id=6c7bfbe9&scoped=true&"
import script from "./ChatMessage.vue?vue&type=script&lang=ts&"
export * from "./ChatMessage.vue?vue&type=script&lang=ts&"
import style0 from "./ChatMessage.vue?vue&type=style&index=0&id=6c7bfbe9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7bfbe9",
  null
  
)

export default component.exports